'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-animated-css/node_modules/react/react.js
// module id = 1122
// module chunks = 0